"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.48,12.93a1.12,1.12,0,0,1,1.12-1.11h1.3c-.69-.36-1.86-.74-3.9-1.48V9a2.7,2.7,0,0,0,1.11-2.17,1.16,1.16,0,0,0,.44-1,1.23,1.23,0,0,0-.35-.94,3.58,3.58,0,0,0,.27-2.12c-.24-1-1.64-1.34-2.77-1.34a3.11,3.11,0,0,0-2.64,1,1,1,0,0,0-1,.38,2.39,2.39,0,0,0,0,2,1.22,1.22,0,0,0-.39,1,1.11,1.11,0,0,0,.46,1A2.67,2.67,0,0,0,8.29,9v1.33c-3.52,1.28-4.45,1.47-4.81,2.4a13.58,13.58,0,0,0-.39,3.16.37.37,0,0,0,.37.37h10Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.54,12.56H14.6a.37.37,0,0,0-.37.37v5.94a.36.36,0,0,0,.37.37h5.94a.37.37,0,0,0,.37-.37V12.93A.38.38,0,0,0,20.54,12.56Zm-2.23,5.2h-2.6a.38.38,0,0,1-.37-.37.37.37,0,0,1,.37-.37h2.6a.37.37,0,0,1,.37.37A.38.38,0,0,1,18.31,17.76Zm1.11-1.49H15.71a.37.37,0,0,1-.37-.37.38.38,0,0,1,.37-.37h3.71a.37.37,0,0,1,.37.37A.36.36,0,0,1,19.42,16.27Zm0-1.48H15.71a.38.38,0,0,1-.37-.37.37.37,0,0,1,.37-.37h3.71a.36.36,0,0,1,.37.37A.37.37,0,0,1,19.42,14.79Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;